import { call, put, takeLatest } from "redux-saga/effects";
import { reportApi } from "../../../api/report/reportApi";
import { IReportRequest } from "../../../model/request/report/IReportRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IPagingReportResult } from "../../../model/respone/report/IReportRespone";
import {
  eReportActionIds,
  IReportActionTypes,
} from "../../action-types/report/IReportActionTypes";
import { rootActions } from "../../actions/rootActions";

export function* reportSaga(): any {
  yield takeLatest(eReportActionIds.LOAD_START, loadWorker);
  yield takeLatest(eReportActionIds.EXPORT_EXCEL_BAO_CAO_START, exportWorker);
}

function* loadWorker(action: IReportActionTypes): any {
  const request = action.payload as IReportRequest;
  const res: IBaseRespone = yield call(reportApi.SelectByPaging, request);
  if (res.is_success) {
    const data: IPagingReportResult = res.data;
    yield put(rootActions.report.report.LOAD_SUCCESS(data));
  } else {
    yield put(rootActions.report.report.LOAD_ERROR(res.message ?? "Có lỗi"));
  }
}

function* exportWorker(action: IReportActionTypes): any {
  const request = action.payload as IReportRequest;
  const res: IBaseRespone = yield call(reportApi.ExportExcel, request);
  if (res.is_success) {
    var data = res.data as string;
    yield put(rootActions.report.report.EXPORT_EXCEL_BAO_CAO_SUCCESS(data));
  } else {
    yield put(
      rootActions.report.report.EXPORT_EXCEL_BAO_CAO_ERRR(
        res.message ?? "Có lỗi"
      )
    );
  }
}
